export const directoryKeys = {
  all: () => ['directories'],
  children: (path: string) => [...directoryKeys.all(), 'children', path],
};
